// src/components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <p>© 2024 Employee Management System. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
